import React from '@root/vendor/react';

const AbTestDispatchContext = React.createContext();

export default AbTestDispatchContext;
